<template>
</template>

<script>
    export default {
        name: 'Iframe',
        props: {
            url: {
                type: String,
                required: true
            }
        },
        methods: {
            resizeIframe(height) {
                height = parseInt(height)

                if (height) {
                    this.$refs['shopIframe'].height = height
                }
            },
            sendPostMessageResize() {
                setTimeout(function () {
                    const wrapper = this.$refs['shopIframe']
                    if (wrapper && window.parent) {
                        window.parent.postMessage((wrapper?.scrollHeight || 0) + 40, '*')
                    }
                }, 250);
            }
        },
        mounted() {
            let _self   = this

            _self.sendPostMessageResize()

            window.addEventListener('message', function (event) {
                _self.resizeIframe(parseInt(event.data))
            }, false);

            window.onresize = _self.sendPostMessageResize

            const script  = document.getElementById('shopScript')
            const wrapper = script.parentNode
            const iframe  = document.createElement('iframe');

            iframe.id = 'shopIframe'
            iframe.width = '100%'
            iframe.src = this.url
            iframe.frameBorder = 0
            iframe.scrolling = 'no'

            wrapper.appendChild(iframe)
        }
    }
</script>

<style>
</style>